import { Helmet } from "react-helmet-async";
import { filter } from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { fDate } from "../../utils/formatTime";

import {
  Card,
  Stack,
  Paper,
  Button,
  Chip,
  Tooltip,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Breadcrumbs,
  DialogTitle,
  DialogActions,
  DialogContent,
  Dialog,
} from "@mui/material";

import Iconify from "../../components/iconify";
import Scrollbar from "../../components/scrollbar";
import { UserListHead, UserListToolbar } from "../../sections/@dashboard/user";
import { deleteBill, getbill, releaseBill } from "../../feature/shippinglistSlice";
import { HomeRounded } from "@mui/icons-material";

import SmartTable from "../../components/SmartTable/SmartTable";
const TABLE_HEAD = [
  { id: "billTitle",    label: "Bill Title",     alignRight: false },
  { id: "address",     label: "Address",         alignRight: false },
  { id: "dilveryDate", label: "Delivery Date",   alignRight: false },
  { id: "orderDate",   label: "Order Date",      alignRight: false },
  { id: "status",      label: "Status",          alignRight: false },
  { id: "" },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) return -1;
  if (b[orderBy] > a[orderBy]) return 1;
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export default function BillofLanding() {
  const dispatch  = useDispatch();
  const navigate  = useNavigate();

  const [page, setPage]               = useState(0);
  const [order, setOrder]             = useState("asc");
  const [selected, setSelected]       = useState([]);
  const [orderBy, setOrderBy]         = useState("billTitle");
  const [filterName, setFilterName]   = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [openDeleteDialog, setOpenDeleteDialog]   = useState(false);
  const [selectedContactId] = useState(null); // eslint-disable-line no-unused-vars

  // Release confirm dialog
  const [openReleaseDialog, setOpenReleaseDialog] = useState(false);
  const [releaseTargetId, setReleaseTargetId]     = useState(null);
  const [releaseTargetTitle, setReleaseTargetTitle] = useState("");

  const { bill, isBillLoading } = useSelector((state) => state.billSlice);

  useEffect(() => {
    dispatch(getbill());
  }, [dispatch]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      setSelected(bill.map((n) => n.billTitle));
      return;
    }
    setSelected([]);
  };

  function applySortFilter(array, comparator, query) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const o = comparator(a[0], b[0]);
      if (o !== 0) return o;
      return a[1] - b[1];
    });
    if (query) {
      return filter(
        bill,
        (_inv) => _inv.billTitle.toLowerCase().indexOf(query.toLowerCase()) !== -1
      );
    }
    return stabilizedThis.map((el) => el[0]);
  }

  const handleChangePage        = (_, newPage)  => setPage(newPage);
  const handleChangeRowsPerPage = (event) => { setPage(0); setRowsPerPage(parseInt(event.target.value, 10)); };
  const handleFilterByName      = (event) => { setPage(0); setFilterName(event.target.value); };

  const handleDelete = (billTitle) => {
    dispatch(deleteBill(billTitle));
    toast("Bill Deleted Successfully!");
  };

  const handleReleaseClick = (id, title) => {
    setReleaseTargetId(id);
    setReleaseTargetTitle(title);
    setOpenReleaseDialog(true);
  };

  const handleReleaseConfirm = () => {
    dispatch(releaseBill(releaseTargetId));
    setOpenReleaseDialog(false);
  };

  const emptyRows     = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - bill.length) : 0;
  const filteredBills = applySortFilter(bill, getComparator(order, orderBy), filterName);
  const isNotFound    = !filteredBills.length && !!filterName;

  return (
    <>
      <Helmet>
        <title>Bill of Lading | SFM</title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Breadcrumbs aria-label="breadcrumb">
            <Stack direction="row" alignItems="center" spacing={1}>
              <HomeRounded color="inherit" />
              <Typography variant="body1" color="textPrimary">
                / Bill of Lading
              </Typography>
            </Stack>
          </Breadcrumbs>
          <Button
            onClick={() => navigate("/add-bill")}
            variant="contained"
            startIcon={<Iconify icon="eva:plus-fill" />}
          >
            New Bill
          </Button>
        </Stack>

        <Card>
          <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center" }}>
            <UserListToolbar
              label={"Search bills..."}
              numSelected={selected.length}
              filterName={filterName}
              onFilterName={handleFilterByName}
            />
            <TablePagination
              rowsPerPageOptions={[10, 25]}
              component="div"
              count={bill.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </div>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 900 }}>
              <SmartTable tableId="bills-of-lading" lockedColumns={["Bill Title", "Status"]}>
                <UserListHead
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={bill.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredBills.length === 0 && !isNotFound && (
                    <TableRow>
                      <TableCell align="center" colSpan={TABLE_HEAD.length} sx={{ py: 3 }}>
                        <Paper sx={{ textAlign: "center" }}>
                          <Typography variant="h6" paragraph>No records found</Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  )}

                  {filteredBills
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      const {
                        id, billTitle, address, dilveryDate, orderDate,
                        status,
                        released_by_name, released_by_position, released_at,
                      } = row;

                      const isReleased = status === "released";

                      return (
                        <TableRow hover key={id} tabIndex={-1}>
                          {/* Bill Title */}
                          <TableCell component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center">
                              <Typography variant="subtitle2" sx={{ padding: "0px 15px" }} noWrap>
                                {billTitle}
                              </Typography>
                            </Stack>
                          </TableCell>

                          {/* Address */}
                          <TableCell align="left">{address}</TableCell>

                          {/* Delivery Date */}
                          <TableCell align="left">{fDate(dilveryDate)}</TableCell>

                          {/* Order Date */}
                          <TableCell align="left">{fDate(orderDate)}</TableCell>

                          {/* Status + sign-off tooltip */}
                          <TableCell align="left">
                            {isReleased ? (
                              <Tooltip
                                title={
                                  <span style={{ lineHeight: 1.8 }}>
                                    <strong>Released by:</strong> {released_by_name || "—"}<br />
                                    <strong>Position:</strong> {released_by_position || "—"}<br />
                                    <strong>Date:</strong> {released_at ? fDate(released_at) : "—"}
                                  </span>
                                }
                                arrow
                              >
                                <Chip
                                  label="Released"
                                  color="success"
                                  size="small"
                                  variant="outlined"
                                  sx={{ fontWeight: 600, cursor: "help" }}
                                />
                              </Tooltip>
                            ) : (
                              <Chip
                                label="Draft"
                                color="warning"
                                size="small"
                                variant="outlined"
                                sx={{ fontWeight: 600 }}
                              />
                            )}
                          </TableCell>

                          {/* Actions */}
                          <TableCell align="right">
                            <Stack direction="row" justifyContent="flex-end" spacing={1}>
                              {!isReleased && (
                                <Button
                                  size="small"
                                  variant="contained"
                                  color="primary"
                                  disabled={isBillLoading}
                                  onClick={() => handleReleaseClick(id, billTitle)}
                                >
                                  Release
                                </Button>
                              )}
                            </Stack>
                          </TableCell>
                        </TableRow>
                      );
                    })}

                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={TABLE_HEAD.length} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={TABLE_HEAD.length} sx={{ py: 3 }}>
                        <Paper sx={{ textAlign: "center" }}>
                          <Typography variant="h6" paragraph>Not found</Typography>
                          <Typography variant="body2">
                            No results for &nbsp;<strong>&quot;{filterName}&quot;</strong>.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </SmartTable>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[10, 25]}
            component="div"
            count={bill.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>

      {/* ── Release confirmation dialog ── */}
      <Dialog open={openReleaseDialog} onClose={() => setOpenReleaseDialog(false)}>
        <DialogTitle>Release Bill of Lading</DialogTitle>
        <DialogContent>
          <Typography>
            Release <strong>{releaseTargetTitle}</strong>? This will record your name, position,
            and timestamp as the approver. This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenReleaseDialog(false)}>Cancel</Button>
          <Button onClick={handleReleaseConfirm} variant="contained" color="primary">
            Confirm Release
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Delete confirmation dialog ── */}
      <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
        <DialogTitle>Delete Bill</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this Bill?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
          <Button
            onClick={() => { handleDelete(selectedContactId); setOpenDeleteDialog(false); }}
            color="error"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
